import LacquersDms from '../../../../components/editable-cell/form-items/lacquers-dms'
import type { ShipmentColumn } from '../../types/column-types'
import { onCellStandard } from '../../helpers/helpers'
import { RotatedTitle } from '../../../../components/rotated-title/rotated-title'
import { hasTaskOfType } from '../../helpers/has-task-of-type'

export const lacquersDmsColumn: ShipmentColumn = {
    key: 'lacquersDms',
    dataIndex: 'lacquersDms',
    title: <RotatedTitle>Лак DMS</RotatedTitle>,
    width: 30,
    editable: true,
    FormItem: <LacquersDms />,
    onCell: (record, index) => ({
        ...onCellStandard(record, index),
        editable: !hasTaskOfType(record, 'Заказ форм'),
    }) as any,
}
